/* eslint-disable */
import { AfterViewInit, Component } from '@angular/core';
import { UIRouter } from '@uirouter/angular';
import { TranslateService } from '@ngx-translate/core';
import { EmptyMessage } from '../../../../lib/util/messages';
import { StateName } from '../../../../app.state-names';
import { Arrays } from '../../../../lib/util/arrays';
import { DocumentTextService } from '../../../../lib/document/document-text.service';
import { DocumentLanguageService } from '../../../../lib/document/document-language.service';
import { DocumentLanguageUtil } from '../../../../util/document/document-language-utils';
import { DocumentGroupService } from '../../../../lib/document/document-group.service';
import { DocumentGroup } from '../../../../lib/document/document-group.service';
import { DocumentGroupItem, LanguageItem } from '../../../../util/document/document-file-utils';
import { UiConstants } from '../../../../util/core-utils';
import { ResourceQueryResult } from '../../../../lib/util/services';
import { DocumentLanguageItem, DocumentTextCreateModel } from '../../../../util/document/document-utils';
/* eslint-enable */

@Component({
  selector: 'app-document-text-create',
  templateUrl: 'document-text-create.component.html',
  styleUrls: ['document-text-create.component.scss']
})
export class DocumentTextCreateComponent implements  AfterViewInit {

  model: DocumentTextCreateModel;
  uploadGlobalErrors: string;
  uploadCollectionFieldErrors: string;
  documentGroupList: DocumentGroupItem[] = [];
  documentLanguageList: DocumentLanguageItem[] = [];
  languageItems: LanguageItem[] = [];

  public options: Object = {
    placeholderText: '',
    charCounterCount: false,
    toolbarButtons: ['undo', 'redo' , '|', 'bold', 'italic', 'underline', 'strikeThrough', 'outdent', 'indent', 'clearFormatting'],
    quickInsertButtons: [],
    pluginsEnabled: []
  };

  constructor(
    private documentGroupService: DocumentGroupService,
    private documentService: DocumentTextService,
    private documentLanguageService: DocumentLanguageService,
    private documentLanguageUtil: DocumentLanguageUtil,
    private translateService: TranslateService,
    private uiRouter: UIRouter) {
    this.model = new DocumentTextCreateModel();
  }

  ngAfterViewInit(): void {
    this.loadDefaultDocumentGroup(() => {
      this.loadDocumentGroups(() => {
        this.loadDocumentLanguageList(() => {
        });
      });
    });
  }

  loadDefaultDocumentGroup(completion: () => void) {
    this.translateService.get('DOCUMENT_GROUP_FILTER_ALL').subscribe(
      (text: string) => {
        const allGroup: DocumentGroupItem = {
          id: null,
          text: text
        };
        this.model.document_group = allGroup;
        this.documentGroupList.push(allGroup);
        completion();
      }
    );
  }

  loadDocumentGroups(completion: () => void) {
    const arrayTemp: DocumentGroup[] = [];

    this.documentGroupService.query({}).subscribe((result: ResourceQueryResult<DocumentGroup>) => {

        result.items.forEach( group => {
          arrayTemp.push(group);
        });

        const sortedArray = arrayTemp.sort((n1, n2) => {
          if (n1.name > n2.name) {
            return 1;
          }

          if (n1.name < n2.name) {
            return -1;
          }

          return 0;
        });
        sortedArray.forEach(group => {
          const groupItem = {
            id: group.id,
            text: group.name
          };
          this.documentGroupList.push(groupItem);
        });
        completion();

      }, (error: any) => {
        completion();
      });

  }

  getDocumentGroupName(documentGroupId: number | null): string {
    let groupName = '';
    if (!documentGroupId) {
      return groupName;
    }
    Arrays.iterateByIndex(this.documentGroupList, (userGroup) => {
      if (userGroup.id === documentGroupId ) {
        groupName = userGroup.text;
      }
    });

    return groupName;
  }

  private loadDocumentLanguageList(completion: () => void) {
    this.documentLanguageService.query().subscribe(
      (result: string[]) => {
        const def = this.documentLanguageUtil.createDefaultLanguageCode();
        this.model.language_code = def;
        this.documentLanguageList.push(def);

        Arrays.iterateByIndex( result, language => {
          const languageItem = new DocumentLanguageItem();
          languageItem.id = language;
          languageItem.text = this.documentLanguageUtil.getDocumentLanguageName(language);
          this.documentLanguageList.push(languageItem);
        });
        completion();

      }, (error: any) => {
        completion();
      });
  }

  update() {

    const code = (this.model.code && this.model.code.length > 0) ? this.model.code : null;
    const languageCodeId = (this.model.language_code) ? this.model.language_code.id : null;
    const document_group_id = (this.model.document_group) ? this.model.document_group.id : null;

    this.documentService.create({
      code: code ? code : undefined,
      name: this.model.name,
      value: this.model.value,
      language_code: languageCodeId ? languageCodeId : undefined,
      document_group_id: document_group_id ? document_group_id : undefined,
      comment: this.model.comment

    }).subscribe(
      (response: EmptyMessage) => {
        this.uiRouter.stateService.go(StateName.DOCUMENT_TEXT_LIST);
      }
    );
  }

  back() {
    window.history.back();
  }

  getTextMaximumLength(): number {
    return UiConstants.maximumVarcharLength;
  }

}
